import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { createCachedSelector } from 're-reselect';
import { secureFetch } from './onboardingSlice';
import { baseOnboardingUrl } from './hooks';

const baseUrl = baseOnboardingUrl;


// Async thunks for API calls
export const createPortRequestTelnyx = createAsyncThunk(
  'portRequest/createPortRequest',
  async ({ onboardingId, phoneNumbers }, { rejectWithValue }) => {
    try {
      const response = await secureFetch(`${baseUrl}/api/onboardings/telnyx/create_draft_port_request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          onboardingId: onboardingId,
          phoneNumbers: phoneNumbers
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create port request');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePortRequestTelnyx = createAsyncThunk(
  'portRequest/updatePortRequest',
  async ({ onboardingId, portRequestId }, { rejectWithValue }) => {
    try {
      const response = await secureFetch(`${baseUrl}/api/onboardings/telnyx/update_draft_port_request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          onboardingId: onboardingId,
          portRequestId: portRequestId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update port request');
      }

      const data = await response.json();
      return { portRequestId, data };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const savePortRequest = createAsyncThunk(
  'portRequest/savePortRequest',
  async ( { onboardingId, portRequestId, saveKey, saveValue} ) => {
    // try {
      console.log("Saving port request ", onboardingId, portRequestId, saveKey, saveValue);
      const response = await secureFetch(`${baseUrl}/api/onboardings/telnyx/save_port_request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          onboardingId: onboardingId,
          portRequestId: portRequestId,
          saveKey: saveKey,
          saveValue: saveValue
        })
      });

      if (!response.ok) {
        throw new Error('Failed to save port request');
      }

      const data = await response.json();
      return data;
    // } catch (error) {
    //   // return rejectWithValue(error.message);
    //   return error.message;
    // }
  }
);

export const sharePortRequestTelnyx = createAsyncThunk(
  'portRequest/sharePortRequest',
  async ({ onboardingId, portRequestId }, { rejectWithValue }) => {
    try {
      const response = await secureFetch(`${baseUrl}/api/onboardings/telnyx/share_port_request_link`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          onboardingId: onboardingId,
          portRequestId: portRequestId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to share port request');
      }

      const url = await response.json()['url'];
      return { portRequestId, url };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const submitPortRequest = createAsyncThunk(
//   'portRequest/submitPortRequest',
//   async ({ portRequestId }, { rejectWithValue }) => {
//     try {
//       const response = await fetch(`${baseUrl}/api/onboardings/telnyx/submit-port-request`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           port_request_id: portRequestId
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Failed to submit port request');
//       }

//       const data = await response.json();
//       return { portRequestId, data };
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const fetchPortRequestsTelnyx = createAsyncThunk(
  'portRequest/fetchPortRequests',
  async ({ onboardingId }, { rejectWithValue }) => {
    try {
      const response = await secureFetch(`${baseUrl}/api/onboardings/telnyx/port_requests/${onboardingId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch port requests');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const initialCreateForm = {
  phoneNumbers: [],
  loading: false,
  error: null
};

const initialPortRequestState = {
  loading: true,
  error: null,
  portRequestOnboarding: null,            // the onboarding object
  portRequestIds: [],                     // port request ids for this onboarding
  currentlyViewedPortRequest: null,       // this is the object we receive and send to telnyx
  activeTabs: ['create'],
  // createForm: initialCreateForm,
  createPhoneNumbers: [],
  shareLink: null,
  portRequestId: null,
  portRequestType: null,
  portRequestRemainingNumbersAction: null,
  portRequestNewBillingPhoneNumber: null,
  portRequestAdminEntityName: null,
  portRequestAdminAuthPersonName: null,
  portRequestAdminBillingPhoneNumber: null,
  portRequestAdminAccountNumber: null,
  portRequestAdminTaxIdentifier: null,
  portRequestAdminPinPasscode: null,
  portRequestAdminBusinessIdentifier: null,
  portRequestLocationStreetAddress: null,
  portRequestLocationExtendedAddress: null,
  portRequestLocationLocality: null,
  portRequestLocationAdministrativeArea: null,
  portRequestLocationPostalCode: null,
  portRequestLocationCountry: null,
  portRequestDocumentsLoa: null,
  portRequestDocumentsInvoice: null,
  portRequestActivationSettingsFocDatetimeRequested: null,
  portRequestPhoneNumberConfigurationBillingGroupId: null,
  portRequestPhoneNumberConfigurationConnectionId: null,
  portRequestPhoneNumberConfigurationMessagingProfileId: null,
  portRequestPhoneNumberConfigurationEmergencyAddressId: null,
  portRequestRequirementGroupId: null
};

// Slice
const portRequestSlice = createSlice({
  name: 'portRequest',
  initialState: initialPortRequestState,
  reducers: {

    clearPortRequestState: (state) => {
      state.portRequestOnboarding = null;
      state.portRequestIds = [];
      state.currentlyViewedPortRequest = null;
      state.activeTabs = ['create'];
      state.createForm = initialCreateForm;
      state.portRequestId = null;
      state.portRequestType = null;
      state.portRequestRemainingNumbersAction = null;
      state.portRequestNewBillingPhoneNumber = null;
      state.portRequestAdminEntityName = null;
      state.portRequestAdminAuthPersonName = null;
      state.portRequestAdminBillingPhoneNumber = null;
      state.portRequestAdminAccountNumber = null;
      state.portRequestAdminTaxIdentifier = null;
      state.portRequestAdminPinPasscode = null;
      state.portRequestAdminBusinessIdentifier = null;
      state.portRequestLocationStreetAddress = null;
      state.portRequestLocationExtendedAddress = null;
      state.portRequestLocationLocality = null;
      state.portRequestLocationAdministrativeArea = null;
      state.portRequestLocationPostalCode = null;
      state.portRequestLocationCountry = null;
      state.portRequestDocumentsLoa = null;
      state.portRequestDocumentsInvoice = null;
      state.portRequestActivationSettingsFocDatetimeRequested = null;
      state.portRequestPhoneNumberConfigurationBillingGroupId = null;
      state.portRequestPhoneNumberConfigurationConnectionId = null;
      state.portRequestPhoneNumberConfigurationMessagingProfileId = null;
      state.portRequestPhoneNumberConfigurationEmergencyAddressId = null;
      state.portRequestRequirementGroupId = null;
    },

    // Whenever the modal is loaded for a new onboarding, we need to fully reset the state
    setPortRequestOnboarding: (state, action) => {
      console.log("setPortRequestOnboarding ", action.payload)

      if (!action.payload?.onboarding)
      {
        state.clearPortRequestState();
        state.loading = true;
        return;
      }
      if (!action.payload?.onboarding?.stages?.portRequest?.final_data)
      {
        console.log("no port request final data");
        state.clearPortRequestState();
        state.loading = true;
        return;
      }

      if (action.payload?.onboarding && action.payload?.onboarding?.id === state.portRequestOnboarding?.id) {
        // same onboarding, do nothing
        return;
      }
      state.portRequestOnboarding = action.payload.onboarding;
      console.log("state.portRequestOnboarding ", state.portRequestOnboarding)
      state.portRequestIds = Object.keys(action.payload.onboarding.stages.portRequest.final_data);
      console.log("state.portRequestIds ", state.portRequestIds);
      state.currentlyViewedPortRequest = null;
      state.activeTabs = ['create'].concat(Object.keys(action.payload.onboarding.stages.portRequest.final_data));
      console.log("state.activeTabs ", state.activeTabs);
      state.activeTab = 'create';
      state.createForm = initialCreateForm;
      state.loading = false;
      state.error = null;
    },

    // Clear errors
    clearError: (state) => {
      state.error = null;
    },

    setCreatePhoneNumbers: (state, action) => {
      console.log("setCreatePhoneNumbers ", action.payload)
      const { index, value } = action.payload;
      if (state.createPhoneNumbers.length  === 0) {
        state.createPhoneNumbers = [value];
      }
      else {
        state.createPhoneNumbers = [...state.createPhoneNumbers.slice(0, index), value, ...state.createPhoneNumbers.slice(index + 1)];
      }
      console.log("state.createPhoneNumbers ", state.createPhoneNumbers)
    },

    setPortRequestType: (state, action) => {
      state.portRequestType = action.payload;
    },
    setPortRequestRemainingNumbersAction: (state, action) => {
      state.portRequestRemainingNumbersAction = action.payload;
    },
    setPortRequestNewBillingPhoneNumber: (state, action) => {
      state.portRequestNewBillingPhoneNumber = action.payload;
    },
    setPortRequestAdminEntityName: (state, action) => {
      state.portRequestAdminEntityName = action.payload;
    },
    setPortRequestAdminAuthPersonName: (state, action) => {
      state.portRequestAdminAuthPersonName = action.payload;
    },
    setPortRequestAdminBillingPhoneNumber: (state, action) => {
      state.portRequestAdminBillingPhoneNumber = action.payload;
    },
    setPortRequestAdminAccountNumber: (state, action) => {
      state.portRequestAdminAccountNumber = action.payload;
    },
    setPortRequestAdminTaxIdentifier: (state, action) => {
      state.portRequestAdminTaxIdentifier = action.payload;
    },
    setPortRequestAdminPinPasscode: (state, action) => {
      state.portRequestAdminPinPasscode = action.payload;
    },
    setPortRequestAdminBusinessIdentifier: (state, action) => {
      state.portRequestAdminBusinessIdentifier = action.payload;
    },
    setPortRequestLocationStreetAddress: (state, action) => {
      state.portRequestLocationStreetAddress = action.payload;
    },
    setPortRequestLocationExtendedAddress: (state, action) => {
      state.portRequestLocationExtendedAddress = action.payload;
    },
    setPortRequestLocationLocality: (state, action) => {
      state.portRequestLocationLocality = action.payload;
    },
    setPortRequestLocationAdministrativeArea: (state, action) => {
      state.portRequestLocationAdministrativeArea = action.payload;
    },
    setPortRequestLocationPostalCode: (state, action) => {
      state.portRequestLocationPostalCode = action.payload;
    },
    setPortRequestLocationCountry: (state, action) => {
      state.portRequestLocationCountry = action.payload;
    },
    setPortRequestDocumentsLoa: (state, action) => {
      state.portRequestDocumentsLoa = action.payload;
    },
    setPortRequestDocumentsInvoice: (state, action) => {
      state.portRequestDocumentsInvoice = action.payload;
    },
    setPortRequestActivationSettingsFocDatetimeRequested: (state, action) => {
      state.portRequestActivationSettingsFocDatetimeRequested = action.payload;
    },
    setPortRequestPhoneNumberConfigurationBillingGroupId: (state, action) => {
      state.portRequestPhoneNumberConfigurationBillingGroupId = action.payload;
    },
    setPortRequestPhoneNumberConfigurationConnectionId: (state, action) => {
      state.portRequestPhoneNumberConfigurationConnectionId = action.payload;
    },
    setPortRequestPhoneNumberConfigurationMessagingProfileId: (state, action) => {
      state.portRequestPhoneNumberConfigurationMessagingProfileId = action.payload;
    },
    setPortRequestPhoneNumberConfigurationEmergencyAddressId: (state, action) => {
      state.portRequestPhoneNumberConfigurationEmergencyAddressId = action.payload;
    },
    setPortRequestRequirementGroupId: (state, action) => {
      state.portRequestRequirementGroupId = action.payload;
    },

    // Whenever the user selects a different port request, we need to update the state
    setCurrentPortRequest: (state, action) => {
      console.log("setCurrentPortRequest ", action.payload)
      const newActiveTab = action.payload.activeTab;
      console.log("newActiveTab ", newActiveTab);
      if (newActiveTab && newActiveTab === state.activeTab) {
        // same port request, do nothing
        return;
      }
      else if (newActiveTab === 'create') {
        // don't need to do anything
      }
      else {
        const tmp = state.portRequestOnboarding.stages.portRequest.final_data[newActiveTab].port_request;
        console.log("tmp ", tmp);
        state.currentlyViewedPortRequest = tmp;

        const misc_tmp = tmp.misc;
        if (misc_tmp) {
          state.portRequestType = misc_tmp.type;
          state.portRequestRemainingNumbersAction = misc_tmp.remaining_numbers_action;
          state.portRequestNewBillingPhoneNumber = misc_tmp.new_billing_phone_number;
        }

        const end_user_tmp = tmp.end_user;
        if (end_user_tmp) {
          const admin_tmp = end_user_tmp.admin;
          if (admin_tmp) {
            state.portRequestAdminEntityName = admin_tmp.entity_name;
            state.portRequestAdminAuthPersonName = admin_tmp.auth_person_name;
            state.portRequestAdminBillingPhoneNumber = admin_tmp.billing_phone_number;
            state.portRequestAdminAccountNumber = admin_tmp.account_number;
            state.portRequestAdminTaxIdentifier = admin_tmp.tax_identifier;
            state.portRequestAdminPinPasscode = admin_tmp.pin_passcode;
            state.portRequestAdminBusinessIdentifier = admin_tmp.business_identifier;
          }

          const location_tmp = end_user_tmp.location;
          if (location_tmp) {
            state.portRequestLocationStreetAddress = location_tmp.street_address;
            state.portRequestLocationExtendedAddress = location_tmp.extended_address;
            state.portRequestLocationLocality = location_tmp.locality;
            state.portRequestLocationAdministrativeArea = location_tmp.administrative_area;
            state.portRequestLocationPostalCode = location_tmp.postal_code;
            state.portRequestLocationCountry = location_tmp.country;
          }
        }

        const documents_tmp = tmp.documents;
        if (documents_tmp) {
          state.portRequestDocumentsLoa = documents_tmp.loa;
          state.portRequestDocumentsInvoice = documents_tmp.invoice;
        }

        const activation_settings_tmp = tmp.activation_settings;
        if (activation_settings_tmp) {
          state.portRequestActivationSettingsFocDatetimeRequested = activation_settings_tmp.foc_datetime_requested;
        }

        const phone_number_configuration_tmp = tmp.phone_number_configuration;
        if (phone_number_configuration_tmp) {
          state.portRequestPhoneNumberConfigurationBillingGroupId = phone_number_configuration_tmp.billing_group_id;
          state.portRequestPhoneNumberConfigurationConnectionId = phone_number_configuration_tmp.connection_id;
          state.portRequestPhoneNumberConfigurationMessagingProfileId = phone_number_configuration_tmp.messaging_profile_id;
          state.portRequestPhoneNumberConfigurationEmergencyAddressId = phone_number_configuration_tmp.emergency_address_id;
        }

        const requirement_group_tmp = tmp.requirement_group;
        if (requirement_group_tmp) {
          state.portRequestRequirementGroupId = requirement_group_tmp.id;
        }

        state.portRequestLoading = false;
        state.portRequestError = null;
        state.activeTab = newActiveTab;
      }

    },

    inputChangePortRequest: (state, action) => {
      const { path, value } = action.payload;
      
      if (!state.currentlyViewedPortRequest || !path || path.length === 0) {
        return;
      }

      // Create a deep copy and update the nested value
      const updateNestedValue = (obj, pathArray, newValue) => {
        if (pathArray.length === 1) {
          return { ...obj, [pathArray[0]]: newValue };
        }
        
        const [firstKey, ...restKeys] = pathArray;
        const currentValue = obj[firstKey];
        
        if (Array.isArray(currentValue)) {
          const index = parseInt(restKeys[0]);
          const newArray = [...currentValue];
          newArray[index] = updateNestedValue(newArray[index], restKeys.slice(1), newValue);
          return { ...obj, [firstKey]: newArray };
        } else if (typeof currentValue === 'object' && currentValue !== null) {
          return { ...obj, [firstKey]: updateNestedValue(currentValue, restKeys, newValue) };
        } else {
          // Create object if it doesn't exist
          const newObj = {};
          newObj[restKeys[0]] = newValue;
          return { ...obj, [firstKey]: newObj };
        }
      };

      state.currentlyViewedPortRequest = updateNestedValue(
        state.currentlyViewedPortRequest, 
        path, 
        value
      );
    },

    // Update create form
    updateCreateForm: (state, action) => {

      //state.createForm = { ...state.createForm, ...action.payload };
    },
  },  
  extraReducers: (builder) => {
    builder
      // Create port request
      .addCase(createPortRequestTelnyx.pending, (state) => {
        state.createForm.loading = true;
        state.createForm.error = null;
      })
      .addCase(createPortRequestTelnyx.fulfilled, (state, action) => {
        state.createForm.loading = false;
        state.portRequests.push(action.payload);
        state.createForm.phoneNumbers = '';
      })
      .addCase(createPortRequestTelnyx.rejected, (state, action) => {
        state.createForm.loading = false;
        state.createForm.error = action.payload;
      })

      // Update port request
      .addCase(updatePortRequestTelnyx.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePortRequestTelnyx.fulfilled, (state, action) => {
        state.loading = true;
        const { portRequestId, data } = action.payload;
        const index = state.portRequests.findIndex(pr => pr.id === portRequestId);
        if (index !== -1) {
          state.portRequests[index] = { ...state.portRequests[index], ...data };
        }
      })
      .addCase(updatePortRequestTelnyx.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Share port request
      .addCase(sharePortRequestTelnyx.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sharePortRequestTelnyx.fulfilled, (state, action) => {
        // state.loading = false;
        state.shareLink = action.payload.url;
        // Handle successful share (e.g., show notification)
      })
      .addCase(sharePortRequestTelnyx.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  }
});

// Export actions
export const {
  setPortRequestOnboarding,
  clearError,
  setCurrentPortRequest,
  inputChangePortRequest,
  updateCreateForm,
  setPortRequestType,
  setPortRequestRemainingNumbersAction,
  setPortRequestNewBillingPhoneNumber,
  setPortRequestAdminEntityName,
  setPortRequestAdminAuthPersonName,
  setPortRequestAdminBillingPhoneNumber,
  setPortRequestAdminAccountNumber,
  setPortRequestAdminTaxIdentifier,
  setPortRequestAdminPinPasscode,
  setPortRequestAdminBusinessIdentifier,
  setPortRequestLocationStreetAddress,
  setPortRequestLocationExtendedAddress,
  setPortRequestLocationLocality,
  setPortRequestLocationAdministrativeArea,
  setPortRequestLocationPostalCode,
  setPortRequestLocationCountry,
  setPortRequestActivationSettingsFocDatetimeRequested,
  setPortRequestPhoneNumberConfigurationBillingGroupId,
  setPortRequestPhoneNumberConfigurationConnectionId,
  setPortRequestPhoneNumberConfigurationMessagingProfileId,
  setPortRequestPhoneNumberConfigurationEmergencyAddressId,
  setPortRequestRequirementGroupId,
  setPortRequestDocumentsLoa,
  setPortRequestDocumentsInvoice,
  setPortRequestPhoneNumberConfigurationTags,
  setCreatePhoneNumbers
} = portRequestSlice.actions;

// Export selectors
export const selectCurrentlyViewedPortRequest = (state) => state.portRequest.currentlyViewedPortRequest;
export const selectPortRequestLoading = (state) => state.portRequest.loading;
export const selectPortRequestError = (state) => state.portRequest.error;
export const selectPortRequestIds = (state) => state.portRequest.portRequestIds;
export const selectCreateForm = (state) => state.portRequest.createForm;
export const selectActiveTab = (state) => state.portRequest.activeTab;
export const selectActiveTabs = (state) => state.portRequest.activeTabs;
export const selectPortRequestOnboarding = (state) => state.portRequest.portRequestOnboarding;

export const selectShareLink = (state) => state.portRequest.shareLink;
export const selectCreatePhoneNumbers = (state) => state.portRequest.createPhoneNumbers;


// FORM VALUES

export const selectPortRequestType = (state) => state.portRequest.portRequestType;
export const selectPortRequestRemainingNumbersAction = (state) => state.portRequest.portRequestRemainingNumbersAction;
export const selectPortRequestNewBillingPhoneNumber = (state) => state.portRequest.portRequestNewBillingPhoneNumber;

export const selectPortRequestAdminEntityName = (state) => state.portRequest.portRequestAdminEntityName;
export const selectPortRequestAdminAuthPersonName = (state) => state.portRequest.portRequestAdminAuthPersonName;
export const selectPortRequestAdminBillingPhoneNumber = (state) => state.portRequest.portRequestAdminBillingPhoneNumber;
export const selectPortRequestAdminAccountNumber = (state) => state.portRequest.portRequestAdminAccountNumber;
export const selectPortRequestAdminTaxIdentifier = (state) => state.portRequest.portRequestAdminTaxIdentifier;
export const selectPortRequestAdminPinPasscode = (state) => state.portRequest.portRequestAdminPinPasscode;
export const selectPortRequestAdminBusinessIdentifier = (state) => state.portRequest.portRequestAdminBusinessIdentifier;

export const selectPortRequestDocumentsLoa = (state) => state.portRequest.portRequestDocumentsLoa;
export const selectPortRequestDocumentsInvoice = (state) => state.portRequest.portRequestDocumentsInvoice;

export const selectPortRequestLocationStreetAddress = (state) => state.portRequest.portRequestLocationStreetAddress;
export const selectPortRequestLocationExtendedAddress = (state) => state.portRequest.portRequestLocationExtendedAddress;
export const selectPortRequestLocationLocality = (state) => state.portRequest.portRequestLocationLocality;
export const selectPortRequestLocationAdministrativeArea = (state) => state.portRequest.portRequestLocationAdministrativeArea;
export const selectPortRequestLocationPostalCode = (state) => state.portRequest.portRequestLocationPostalCode;
export const selectPortRequestLocationCountry = (state) => state.portRequest.portRequestLocationCountry;
export const selectPortRequestActivationSettingsFocDatetimeRequested = (state) => state.portRequest.portRequestActivationSettingsFocDatetimeRequested;
export const selectPortRequestPhoneNumberConfigurationBillingGroupId = (state) => state.portRequest.portRequestPhoneNumberConfigurationBillingGroupId;
export const selectPortRequestPhoneNumberConfigurationConnectionId = (state) => state.portRequest.portRequestPhoneNumberConfigurationConnectionId;
export const selectPortRequestPhoneNumberConfigurationMessagingProfileId = (state) => state.portRequest.portRequestPhoneNumberConfigurationMessagingProfileId;
export const selectPortRequestPhoneNumberConfigurationEmergencyAddressId = (state) => state.portRequest.portRequestPhoneNumberConfigurationEmergencyAddressId;
export const selectPortRequestRequirementGroupId = (state) => state.portRequest.portRequestRequirementGroupId;


// Export reducer
export default portRequestSlice.reducer;
